import { useEffect, useState } from 'react'

// true once the page is scrolled more than `offset` px.
// The scroll position is read at most once per frame (requestAnimationFrame),
// before React updates the DOM, and the listener is passive: no forced reflow
// and no scroll jank.
const useScrolledPast = (offset) => {
  const [scrolledPast, setScrolledPast] = useState(false)

  useEffect(() => {
    let frame = null
    const update = () => {
      frame = null
      setScrolledPast(window.scrollY > offset)
    }
    const onScroll = () => {
      if (frame === null) frame = window.requestAnimationFrame(update)
    }

    onScroll() // first read in the next frame too, not synchronously during mount
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      if (frame !== null) window.cancelAnimationFrame(frame)
    }
  }, [offset])

  return scrolledPast
}

export default useScrolledPast
